module.exports = __webpack_public_path__ + "static/media/profile-william.78087f2b.jpg";